import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import Icon from 'flarum/common/components/Icon';
import emoji from '../../common/util/emoji';
export default class PostReactedNotification extends Notification {
  icon() {
    return 'fas fa-heart';
  }
  href() {
    return app.route.post(this.attrs.notification.subject());
  }
  content() {
    const notification = this.attrs.notification;
    const _JSON$parse = JSON.parse(notification.content()),
      identifier = _JSON$parse.identifier,
      type = _JSON$parse.type;
    const user = notification.fromUser();
    const reaction = type === 'emoji' ? m("img", {
      src: emoji(identifier).url,
      loading: "lazy",
      height: "14px"
    }) : m(Icon, {
      name: identifier
    });
    return app.translator.trans('ziven-reactions.forum.notification', {
      user,
      reaction
    });
  }
  excerpt() {
    return this.attrs.notification.subject().contentPlain();
  }
}
flarum.reg.add('ziiven-ziven-reactions', 'forum/components/PostReactedNotification', PostReactedNotification);